export default __webpack_public_path__ + "static/media/img_02.6d8769f2.jpg";